<!-- 查询灯控亮灯率日度趋势 -->
<template>
  <div class="alarm-time-list">
    <div class="device-name">灯控近七天亮灯率</div>
    <div class="tabList">
      <chartsLine :option="lineData" id="QueryLightOpenRate" :key="setRefresh"></chartsLine>
      <!-- <div class="tabList-box" v-for="el,index in list" :key="index">
        <div>{{el.date}}</div>
        <div>{{el.rate}}%</div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'QueryLightOpenRate',
  components: {
  },
  data() {
    return {
      list: [],
      setRefresh:0,
      lineData: {
        color: ["#4ED499"],
        title: "",
        x: [],
        unit: "%",
        series: [
          {
            name: "",
            data: [],
          }
        ],
        setSeries: {
          smooth: false, //平滑折线图
          //下阴影
        },
        cover: {
          legend: {
            padding: [5, 10],
            top: '5%',
            data: []
          },
        }
      },
    }
  },
  computed: {
    ...mapState('cmd', ['windowOnResize']),
    ...mapGetters('auth', ['funCodes', 'showLang']),
  },
  watch: {
    windowOnResize(){
      this.setRefresh++;
    }
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init() {
      let ajaxData = {
        "start": "2024-05-01",
        "end": "2024-05-11"
      }
      let now = new Date();
      now.setDate(now.getDate());
      ajaxData.end = now.format('yyyy-MM-dd HH:mm:ss');
      now.setDate(now.getDate() - 7);
      ajaxData.start = now.format('yyyy-MM-dd HH:mm:ss');
      this.$axios.post(`device/light/QueryLightOpenRate`, ajaxData).then(res => {
        if (res.code == 0) {
          this.$set(this, 'list',res.data);
          this.list.forEach(ele => {
            this.lineData.x.push(ele.date.slice(8, 11)+'日')
            this.lineData.series[0].data.push(ele.rate)
          });
          this.setRefresh++;
        }
      });
    }
  }
}
</script>
<style scoped>
.alarm-time-list {
  height: 100%;
  width: 100%;
  /* border: solid 1px red; */
  display: flex;
  flex-direction: column;
}
.device-name {
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 20px;
  color: #333333;
  border-left: 3px solid #3379fb;
  line-height: 20px;
  text-indent: 9px;
}
.tabList {
  width: 98%;
  height: calc(100% - 30px);
}
</style>